import { render, staticRenderFns } from "./ApplyList.vue?vue&type=template&id=68fc54d3&scoped=true&"
import script from "./ApplyList.vue?vue&type=script&lang=js&"
export * from "./ApplyList.vue?vue&type=script&lang=js&"
import style0 from "./ApplyList.vue?vue&type=style&index=0&id=68fc54d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc54d3",
  null
  
)

export default component.exports